import React from 'react';
import factory from 'components/Icons/factory';

export const ExternalLink = factory(
  'ExternalLink',
  <g transform="translate(14.000000, 13.000000)">
    <polygon points="0 0.0001 0 100.0001 100 100.0001 100 59.0001 87 59.0001 87 88.0001 12 88.0001 12 13.0001 41 13.0001 41 0.0001" />
    <polygon points="53.0001 0.0001 53.0001 12.5001 56.2501 16.0001 73.3261 16.0001 34.3261 54.8131 37.5001 62.5941 45.1871 65.7211 84.0001 26.6731 84.0001 43.7501 87.5001 47.0001 100.0001 47.0001 100.0001 0.0001" />
  </g>
);

export default ExternalLink;
